import { muiTypography } from "./base";

// shared Styling
export const CustomTypography = {
  fontFamily: muiTypography.fontFamily,
  h1: muiTypography.h1,
  h2: muiTypography.h2,
  h3: muiTypography.h3,
  h4: muiTypography.h4,
  h5: muiTypography.h5,
  h6: muiTypography.h6,
  subtitle1: muiTypography.subtitle1,
  subtitle2: muiTypography.subtitle2,
  body1: muiTypography.body1,
  body2: muiTypography.body2,
  fontWeightLight: 300,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightBold: 700,
  button: { ...muiTypography.button },
  caption: { ...muiTypography.caption },
  overline: { ...muiTypography.overline },
};


export const CustomLightPalette = {
          

  primary: {
    main:  "rgb(99, 102, 241)", // the purple color across app in buttons
    light: "#41a9a5", // the light green color when hover on add button
  },
  background: {
    default: "#F9FAFC", // background of the app
  },
  sideMenu: {
    text: "#FFFFFF", // side menu text color 
    selected: "#FFFFFF40", // side menu action text color (hover or selected)
    bg: "#000000", // side menu background
    
  },
};


export const CustomDarkPalette = {
  primary: {
    light: "#41a9a5",
    main: "#12948f",
    dark: "#0c6764",
  },
  secondary: {
    light: "#368c9d",
    main: "#047085",
    dark: "#024e5d",
  },
  text: {
    primary: "#1c164a",
    secondary: "#d3d1df",
  },
  background: {
    paper: "#fff",
    default: "#f3f3f3",
  },

};